import { API_URL } from '../../env';

export const fetcher = async (url: string, options: any = {}) =>
  await fetch(`${API_URL}${url}`, updateOptions(options));

const updateOptions = (options: any) => {
  const update = { ...options };
  const bearer = JSON.parse(localStorage?.OUTDORIA_AUTH ?? '{}')?.bearer;
  const adventure = JSON.parse(localStorage?.OUTDORIA_ADVENTURE ?? '{}')?.id;

  update.headers = {
    ...update.headers,
    ...(adventure ? { 'X-Adventure': adventure } : {}),
    ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
  };
  return update;
};
